import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./buySellTable.style.scss";

const BuySellTable = ({ heading, tableData }) => {
  return (
    <div style={{ overflow: "auto" }}>
      <table className="table table-bordered current_buySell_table">
        <thead>
          <tr>
            {heading &&
              heading.map((el, i) => (
                <th
                  key={`${el}-${i}`}
                  style={{
                    width: i === 1 || i === 3 || i === 4 ? "150px" : "",
                  }}
                >
                  {el}
                </th>
              ))}
          </tr>
        </thead>
        <tbody className="buy_sell_table">
          {tableData.map((e, i) => (
            <tr key={`${i}-${e[0]}`}>
              <td>{e[0]}</td>
              <td style={{ width: "150px" }}>{e[1]}</td>
              <td>{e[2]}</td>
              <td style={{ width: "150px" }}>{e[3]}</td>
              <td style={{ width: "150px" }}>
                {e[4].includes("sell") ? (
                  <Fragment>
                    <span className="badge bdg_orange">SELL</span> &nbsp;
                    {/* {`${e[5]} % `} */}
                  </Fragment>
                ) : e[4].includes("buy") ? (
                  <Fragment>
                    <span className="badge bdg_blue">BUY</span> &nbsp;
                    {/* {`${Number(e[5]).toFixed(2)} % `} */}
                  </Fragment>
                ) : e[4].includes("reduce") ? (
                  <Fragment>
                    <span className="badge bdg_orange">REDUCE</span> &nbsp;
                    {/* {`${Number(e[5]).toFixed(2)} % `} */}
                  </Fragment>
                ) : e[4].includes("increase") ? (
                  <Fragment>
                    <span className="badge bdg_blue">INCREASE</span> &nbsp;
                    {/* {`${Number(e[5]).toFixed(2)} % `} */}
                  </Fragment>
                ) : e[4].includes("hold") ? (
                  <Fragment>
                    <span className="badge bdg_blue">Hold</span> &nbsp;
                    {/* {`${Number(e[5]).toFixed(2)} % `} */}
                  </Fragment>
                ) : (
                  ""
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

BuySellTable.propTypes = {
  heading: PropTypes.arrayOf(PropTypes.string).isRequired,
  tableData: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
  ),
};
export default BuySellTable;



// WEBPACK FOOTER //
// ./src/components/common/buySellTable/buySellTable.jsx